import { Message } from "@/types/chat";
import { formatTextWithBold } from "@/utils/textFormatting";
import { TypingIndicator } from "./TypingIndicator";

interface ChatMessageProps {
  message: Message;
}

export const ChatMessage = ({ message }: ChatMessageProps) => {
  const renderParagraphs = (text: string) => {
    return text.split('\n').map((paragraph, index) => {
      // Skip empty paragraphs to avoid unnecessary spacing
      if (!paragraph.trim()) return null;
      
      return (
        <p 
          key={`p-${index}`} 
          className={`
            ${index !== 0 ? 'mt-3' : ''} 
            leading-relaxed 
            tracking-wide
            ${message.isUser ? 'text-primary-foreground/95' : 'text-muted-foreground'}
          `}
        >
          <span 
            dangerouslySetInnerHTML={{ 
              __html: formatTextWithBold(paragraph) 
            }} 
            className="text-[15px] md:text-base transition-all duration-200"
          />
        </p>
      );
    }).filter(Boolean); // Remove null entries
  };

  return (
    <div 
      className={`
        flex 
        ${message.isUser ? "justify-end" : "justify-start"} 
        mb-4 md:mb-6 
        px-2 md:px-3
        animate-fade-in
      `}
    >
      <div
        className={`
          max-w-[88%] md:max-w-[85%] 
          p-4 md:p-5
          rounded-2xl 
          ${message.isUser 
            ? "bg-primary text-primary-foreground rounded-br-sm" 
            : "bg-muted/95 text-muted-foreground rounded-bl-sm hover:bg-muted/90"
          }
          shadow-sm
          transition-all
          duration-300
          ease-in-out
          backdrop-blur-sm
          hover:shadow-md
          transform hover:-translate-y-0.5
          whitespace-pre-line
        `}
      >
        <div className="prose prose-sm md:prose-base prose-invert max-w-none space-y-2">
          {renderParagraphs(message.text)}
          {message.isTyping && (
            <TypingIndicator className="ml-1 mt-2" />
          )}
        </div>
      </div>
    </div>
  );
};